import type { UrlEntry, UrlRegion } from '@/types';

export const urls: Record<'blogArticle', Record<UrlRegion, UrlEntry>> = {
  blogArticle: {
    de: 'blog',
    'de-en': 'blog',
    es: 'blog',
    'es-en': 'blog',
    fr: 'blog',
    'fr-en': 'blog',
    gb: 'blog',
    nl: 'blog',
    'nl-en': 'blog',
    pt: 'blog',
    'pt-en': 'blog',
    us: 'blog',
    ww: 'blog',
  },
};
